<template>
  <div>
    <bread-crumb></bread-crumb>
    <!--    <search></search>-->
    <manFormList
      :select="select"
      :selectList="selectList"
      @empty="empty"
      :num="num"
      :isBtn="isBtn"
      @getChangeValue="getChangeValue"
    >
    </manFormList>
    <div class="content-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <span slot="label" class="slot-item">
            <span>全部</span>
            <span>{{ businessAccountCountStaus.totalCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane name="pending">
          <span slot="label" class="slot-item">
            <span>待审核</span>
            <span>{{ businessAccountCountStaus.unAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane name="passed">
          <span slot="label" class="slot-item">
            <span>已通过</span>
            <span>{{ businessAccountCountStaus.passAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane name="rejected">
          <span slot="label" class="slot-item">
            <span>已驳回</span>
            <span>{{ businessAccountCountStaus.rejectAuditCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane name="frozen">
          <span slot="label" class="slot-item">
            <span>已冻结</span>
            <span>{{ businessAccountCountStaus.frozenCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
      </el-tabs>

      <pagination
        @sizePageChange="paginationChangeProduct"
        :paginationDatas="paginationDataProduct"
      >
      </pagination>

      <modal
        :isShow.sync="auditDialog"
        title="审核"
        :width="width"
        :isShowBtn="[false, false]"
        :btnText="[]"
      >
        <el-form
          :model="auditForm"
          label-width="100px"
          class="demo-ruleForm"
          :rules="rules"
          ref="audit"
        >
          <el-form-item label="作者昵称" v-if="auditForm.nickName">
            <span>{{ auditForm.nickName }}</span>
          </el-form-item>
          <el-form-item label="作者身份" v-if="auditForm.identity">
            <span>{{ auditIdentity(auditForm.identity) }}</span>
          </el-form-item>
          <el-form-item label="审核意见" prop="status">
            <el-radio-group v-model="auditForm.Status">
              <el-radio :label="2">通过</el-radio>
              <el-radio :label="3">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="驳回理由"
            prop="freeze"
            v-if="auditForm.Status === 3 ? true : false"
          >
            <el-input
              size="small"
              type="textarea"
              placeholder="请输入"
              v-model="auditForm.freeze"
              maxlength="150"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <div class="auditDialog-btns">
            <el-button type="primary" @click="submitForm('audit')"
              >确定</el-button
            >
            <el-button @click="resetForm('audit')">取消</el-button>
          </div>
        </el-form>
      </modal>

      <modal
        :width="width"
        :isShow.sync="freezeDialog"
        title="确认冻结"
        :isShowBtn="[false, false]"
        :btnText="[]"
      >
        <el-form
          :model="auditForm"
          label-width="100px"
          class="demo-ruleForm"
          :rules="freeze"
          ref="freeze"
        >
          <el-form-item label="冻结理由" prop="freeze">
            <el-input
              size="small"
              type="textarea"
              placeholder="请输入"
              v-model="auditForm.freeze"
              maxlength="150"
              show-word-limit
            >
            </el-input>
          </el-form-item>
          <div class="freezeDialog-btns">
            <el-button type="primary" @click="submitForm('freeze')"
              >确定</el-button
            >
            <el-button @click="resetForm('freeze')">取消</el-button>
          </div>
        </el-form>
      </modal>

      <modal
        :width="width"
        :isShow.sync="formDialog"
        :title="tableVal.auditStatus == 3 ? '驳回原因' : '冻结原因'"
        :isShowBtn="[false, true]"
        :btnText="['取消', '确定']"
        @clickHandler="ClickHandler"
      >
        <div class="dialog-conter">{{ tableVal.remark }}</div>
      </modal>
    </div>
  </div>
</template>

<script>
import utils from "../../../../utils";
import pagination from "../../../../components/pagination";
import baseTable from "../../../../components/baseTable";
import search from "../../components/search";
import breadCrumb from "../../../../components/breadCrumb";
import dialogForm from "../../../../components/dialogForm";
import modal from "../../../../components/modal";
import manFormList from "../../components/manFormList";
import {
  queryAllIdentity,
  // reviewCreatorAccount,
  updateCreatorAccountIdentity,
  listContentBusinessForUserMan,
  changheCreatorAccountStatus,
  manPageMediaCertification,
  manCountMediaCertificatio,
  manAuditMediaCertificatio,
} from "../../../../api/man";

export default {
  name: "carryAudit",
  data() {
    return {
      num: 4,
      selectList: {
        article: "",
        contributeTime: "",
        business: "",
        pin: "",
      },
      select: [
        {
          prop: "article",
          type: "input",
          placeholder: "请输入用户ID",
          maxLenth: 10,
        },
        {
          prop: "contributeTime",
          type: "picker",
          placeholder: "请选择申请时间",
        },
        {
          prop: "business",
          type: "input",
          placeholder: "请输入写手昵称",
          maxLenth: 50,
          // List: [],
        },
        {
          prop: "pin",
          type: "input",
          placeholder: "请输入用户pin",
          maxLenth: 18,
          // List: [],
        },
      ],
      businessAccountCountStaus: {},
      freeze: {
        freeze: [
          { required: true, message: "请填写冻结理由", trigger: "blur" },
        ],
      },
      rules: {
        status: [{ message: "请选择审核意见", trigger: "change" }],
        freeze: [
          { required: true, message: "请填写驳回理由", trigger: "blur" },
        ],
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      width: "414px",
      imgHost: "//image.healthjd.com/da/",
      auditDialog: false,
      freezeDialog: false,
      isShowBtn: [true, true],
      btnTextAudit: ["驳回", "通过"],
      btnTextFreeze: ["取消", "确认"],
      // btnTextEditrole: ["取消", "确认"],
      btnText: ["取消", "确认"],
      activeName: "all",
      formDialog: false,
      auditForm: {
        remark: "",
        // exampleUrl: "",
        // identityCode: "",
        Status: -1,
        freeze: "",
      },
      identityList: [],
      accountTypeList: [
        {
          label: "JD账号",
          value: 2,
        },
        {
          label: "ERP账号",
          value: 1,
        },
        {
          label: "其他账号",
          value: 3,
        },
      ],
      // businessList: [],
      // freezeForm: {
      //   freeze: ""
      // },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "用户ID",
            prop: "contentUserId",
          },
          {
            label: "头像",
            prop: "headPic",
            tableStatus: "headPic",
          },
          {
            label: "京东pin",
            prop: "userPin",
          },
          {
            label: "写手昵称",
            prop: "contentUserNickName",
          },
          {
            label: "平台昵称",
            prop: "mediaNickName",
          },
          {
            label: "个人简介",
            prop: "briefing",
            tableStatus: "briefing",
          },
          {
            label: "后台截图",
            prop: "certificationImg",
          },
          {
            label: "平台",
            prop: "dicCode",
            tableStatus: "dicCode",
          },
          {
            label: "主页链接",
            prop: "homePageUrl",
          },
          {
            label: "提交时间",
            prop: "createTime",
            tableStatus: "createTime",
          },
          {
            label: "审核时间",
            prop: "auditTime",
            tableStatus: "auditTime",
          },
          {
            label: "审核人",
            prop: "auditUser",
            tableStatus: "auditUser",
          },
          {
            label: "状态",
            prop: "auditStatus",
            tableStatus: "auditStatus",
          },
        ],
        tableType: 14,
      },
      isBtn: 1,
      tableVal: {},
      status: {
        auditStatus: "",
        accountStatus: "",
      },
      businessOptions: [],
      // businessTag: []
    };
  },
  components: {
    // search,
    breadCrumb,
    baseTable,
    modal,
    // dialogForm,
    pagination,
    manFormList,
  },
  watch: {
    // 'selectList.article'(newVal,oldVal){
    // console.log(newVal,'watch');
    // if(!this.$utils.checkNumber(newVal)){
    //   this.$message({
    //     message: 'ID只能为数字类型',
    //     type: 'warning'
    //   });
    // }
    // this.$utils.checkNumber(newVal)
    // }
  },
  created() {
    this.manPageMediaCertification();
    this.manCountMediaCertificatio();
    this.queryAllIdentity();
    this.listContentBusinessForUserMan();
  },
  methods: {
    auditIdentity(data) {
      switch (data) {
        case 0:
          return "未知";
        case 1:
          return "写手";
        case 2:
          return "医护";
        case 3:
          return "运营";
        default:
          return data;
      }
    },
    getChangeValue() {
      if (!this.$utils.checkNumber(this.selectList.article)) {
        return this.$message({
          message: "ID只能为数字类型",
          type: "warning",
        });
      }
      (this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      }),
        this.manPageMediaCertification();
    },
    empty() {
      Object.keys(this.selectList).map((item) => {
        this.selectList[item] = "";
      });
      this.manPageMediaCertification();
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.manPageMediaCertification();
    },
    ClickHandler(type) {
      if (type === "two") {
        this.formDialog = false;
      }
    },
    submitForm(formName) {
      console.log(
        "🚀 ~ file: carryAudit.vue:391 ~ submitForm ~ type:",
        formName,
        this.auditForm
      );
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName === "freeze") {
            // 冻结
            this.manAuditMediaCertificatio(4);
            this.freezeDialog = false;
          } else if (formName === "audit") {
            // 审核
            if ([2, 3].includes(this.auditForm.Status)) {
              this.manAuditMediaCertificatio(this.auditForm.Status);
              this.auditDialog = false;
            } else {
              this.$message.error("请选择审核意见");
            }
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      if (formName === "freeze") {
        this.freezeDialog = false;
      } else if (formName === "audit") {
        this.auditDialog = false;
      }
    },

    TabhandleClick(val) {
      console.log("🚀 ~ file: carryAudit.vue:545 ~ TabhandleClick ~ val:", val);
      this.tableVal = val.val;
      if (val.type === "audit") {
        // 审核
        this.auditForm.freeze = "";
        this.auditForm.Status = 0;
        this.auditForm.remark = val.val.remark;
        this.auditForm.nickName = val.val.contentUser
          ? val.val.contentUser.nickName
          : "";
        this.auditForm.identity = val.val.contentUser
          ? val.val.contentUser.identity
          : 0;

        this.queryAllIdentity(val.val.pin);
        this.auditDialog = true;
      } else if (val.type === "examine") {
        // 查看理由
        this.formDialog = true;
      } else if (val.type === "freeze") {
        // 冻结
        this.auditForm.freeze = "";
        this.freezeDialog = true;
      } else if (val.type === "thaw") {
        console.log("我是解冻的");
        // 解冻
        this.$confirm("确定要解冻吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.auditForm.freeze = "";
            this.manAuditMediaCertificatio(2);
            // this.$message({
            //   type: "success",
            //   message: "解冻成功!"
            // });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    handleClick(tab, event) {
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };

      if (this.activeName === "all") {
        this.status.auditStatus = "";
        this.status.accountStatus = "";
        this.manPageMediaCertification();
      } else if (this.activeName === "pending") {
        this.status.auditStatus = 1;
        this.status.accountStatus = "";
        this.manPageMediaCertification();
      } else if (this.activeName === "passed") {
        this.status.auditStatus = 2;
        this.status.accountStatus = "";
        this.manPageMediaCertification();
      } else if (this.activeName === "rejected") {
        this.status.auditStatus = 3;
        this.status.accountStatus = "";
        this.manPageMediaCertification();
      } else if (this.activeName === "frozen") {
        this.status.auditStatus = 4;
        this.status.accountStatus = "";
        this.manPageMediaCertification();
      }
    },
    // 获取业务
    listContentBusinessForUserMan() {
      listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res?.contentBusinesses?.forEach((item) => {
          this.businessOptions.push({
            label: item.name,
            value: item.id,
          });
        });
        // this.select[4].List = arr
      });
    },
    // 获取创作者账号全部身份
    queryAllIdentity(pin) {
      queryAllIdentity({
        tenantId: this.$commonJs.getTenantId(),
        // pin: pin,
      }).then((res) => {
        this.identityList = res;
        let arr = [];
        res.map((item) => {
          arr.push({
            value: item.identityCode,
            label: item.identityDesc,
          });
          this.select[1].List = arr;
        });
      });
    },
    // 审核
    manAuditMediaCertificatio(status) {
      manAuditMediaCertificatio({
        tenantId: this.$commonJs.getTenantId(),
        // creatorAccountId: this.tableVal.id,
        id: this.tableVal.id,
        auditStatus: status,
        // pin: this.tableVal.pin,
        // identity: this.auditForm.identityCode,
        remark: this.auditForm.freeze,
        // businessIds: this.businessTag
      }).then((res) => {
        this.$message.success("提交成功");
        // this.activeName = 'all'
        setTimeout(() => {
          this.manPageMediaCertification();
        }, 1000);
        // this.manCountMediaCertificatio()
      });
    },

    // 修改创作者账号身份
    // updateCreatorAccountIdentity() {
    //   console.log(this.tableVal)
    //   updateCreatorAccountIdentity({
    //     tenantId: this.$commonJs.getTenantId(),
    //     creatorAccountId: this.tableVal.id,
    //     identityCode: this.editroleForm.identityCode,
    //     pin: this.tableVal.pin,
    //     businessIds: this.businessTag
    //   }).then(res => {
    //     this.manPageMediaCertification();
    //     // this.manCountMediaCertificatio()
    //     // this.activeName = 'all'
    //   });
    // },
    //
    manCountMediaCertificatio() {
      manCountMediaCertificatio({
        tenantId: this.$commonJs.getTenantId(),
        contentUserId: this.selectList.article,
        // identityCode: this.selectList.articleType === '全部' ? '' : this.selectList.articleType,
        startSubmitTime: utils.isEmpty(this.selectList.contributeTime)
          ? ""
          : utils.timetamp(Number(this.selectList.contributeTime[0])),
        // nickName: this.selectList.business,
        contentUserNickNamePrefix: this.selectList.business,
        // businessId:this.selectList.businessId,
        // auditStatus:auditStatus,
        // accountStatus:accountStatus,
        endSubmitTime: utils.isEmpty(this.selectList.contributeTime)
          ? ""
          : utils.timetamp(Number(this.selectList.contributeTime[1])),
        userPin: this.selectList.pin,
      }).then((res) => {
        console.log(
          "🚀 ~ file: carryAudit.vue:739 ~ manCountMediaCertificatio ~ res:",
          res
        );
        if (res && res.length > 0) {
          let obj = {};
          res.forEach((item) => {
            if (item.key == "ALL") {
              obj.totalCount = item.count;
            } else if (item.key == "UN_AUDIT") {
              obj.unAuditCount = item.count;
            } else if (item.key == "PASS_AUDIT") {
              obj.passAuditCount = item.count;
            } else if (item.key == "REJECT_AUDIT") {
              obj.rejectAuditCount = item.count;
            } else if (item.key == "FROZEN") {
              obj.frozenCount = item.count;
            }
          });
          this.businessAccountCountStaus = obj;
        }
      });
    },
    // 分页
    manPageMediaCertification() {
      let vm = this;

      manPageMediaCertification({
        tenantId: this.$commonJs.getTenantId(),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        contentUserId: this.selectList.article,
        // identityCode: this.selectList.articleType === '全部' ? '' : this.selectList.articleType,
        userPin: this.selectList.pin,
        startSubmitTime: utils.isEmpty(this.selectList.contributeTime)
          ? ""
          : utils.timetamp(Number(this.selectList.contributeTime[0])),
        // nickName: this.selectList.business,
        contentUserNickNamePrefix: this.selectList.business,
        auditStatus: this.status.auditStatus,
        // accountStatus: this.status.accountStatus,
        endSubmitTime: utils.isEmpty(this.selectList.contributeTime)
          ? ""
          : utils.timetamp(Number(this.selectList.contributeTime[1])),
      }).then((res) => {
        console.log("创作者出参", res);
        vm.tableData.tableList.splice(0, vm.tableData.tableList.length);
        res.data.map((item) => {
          // if(item.certificationImg){
          item.certificationImg = this.imgHost + item.certificationImg;
          // }else{
          //   item.certificationImg = ""
          // }

          if (item.accountStatus === 3) {
            item.auditStatus = 4;
          } else {
            item.auditStatus = item.auditStatus;
          }
          vm.tableData.tableList.push(item);
        });
        vm.paginationDataProduct.total = res.totalCount;
        vm.paginationDataProduct.currentPage = res.pageNo;
        vm.paginationDataProduct.pageSize = res.pageSize;
        this.manCountMediaCertificatio();
      });
    },
  },
};
</script>
<style scoped lang="scss">
// .el-form-item__content :deep(.el-textarea .el-input--small) {
//     width: 276px !important;
// }
:deep(.el-textarea__inner) {
  // height: 100%;
  min-height: 130px !important;
  // width: 276px !important;
}

.demo-ruleForm {
  padding: 30px;
  padding-left: 0px;
  padding-bottom: 0;
}
.el-input--small :deep(.el-input__inner) {
  width: 215px;
}
.dialog-conter {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  // padding-bottom: 0px;
  text-align: center;
}
.rejectInp {
  max-height: 130px;
  max-width: 276px;
  overflow: hidden;
}
:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}
.authorUrl {
  // display: inline-block;
  width: 240px;
  word-wrap: break-word;
  word-break: normal;
  // line-height: 1px;
}
.auditDialog-btns,
.freezeDialog-btns {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}
</style>
